/*

? First, let's import the interface that will describe the shape of our business profile object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the business profile activity logs object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

const business_profile_activity_logs_data: StateInterface["business_profile_activity_logs"] = {
	_id: "",
	activity_log: {
		_id_copy: "",
		business_profile_id: "",
		affected_entity: {
			entity_type: "",
			entity_id: "",
		},
		activity_type: "",
		activity_description: "",
		action_performed_by: {
			is_business_profile: false,
			user_id: "",
			business_profile_id: "",
			role: "",
		},
		edited_field: {
			field_name: "",
			previous_value: "",
			new_value: "",
		},
		affected_user: {
			is_business_profile: false,
			user_id: "",
			business_profile_id: "",
			role: "",
		},
		on_click_url: "",
	},
	action_performed_at: new Date(),
};

export const business_profile_activity_logs = business_profile_activity_logs_data;
export default business_profile_activity_logs;
